import styled from "styled-components";
import { ReactComponent as BrandLogo } from "../../assets/burger/burger-logo.svg";

const MobileBrandLogo = styled(BrandLogo).attrs({
  role: "img",
  "aria-label": "ProgPath",
})`
  display: block;

  @media (max-width: 768px) {
    /* The root path is the ProgPath wordmark. */
    > path {
      fill: var(--text-primary, #203a49);
    }
  }
`;

export default MobileBrandLogo;
